import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/contribute", label: "Contribute" },
    { to: "/wall", label: "Wall" },
    { to: "/forests", label: "Forests" },
    { to: "/letters", label: "Letters" },
    { to: "/farms", label: "From Space" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-sritaru-700 text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Brand */}
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl">&#127795;</span>
            <span className="text-xl font-bold tracking-wide">
              SriTaru Sankalpam
            </span>
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-sritaru-800 text-white"
                    : "text-sritaru-100 hover:bg-sritaru-600 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://kathakala.us"
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 py-2 rounded-md text-sm font-medium text-earth-100 hover:bg-sritaru-600 hover:text-white transition-colors border border-sritaru-500"
            >
              Kathakala.us
            </a>
          </div>

          {/* Mobile hamburger */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white focus:outline-none p-2"
              aria-label="Toggle menu"
            >
              {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive(link.to)
                    ? "bg-sritaru-800 text-white"
                    : "text-sritaru-100 hover:bg-sritaru-600"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://kathakala.us"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 rounded-md text-base font-medium text-earth-100 hover:bg-sritaru-600 border border-sritaru-500"
            >
              Kathakala.us
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
